define('pages/news_form/news_form_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/news_form/news_form_view',

  'text!./news_form_page_template.html'

], function (Backbone, $, _, NewsFormView, news_form_page_template) {
  'use strict';
  var View = Backbone.View.extend({

    initialize: function (opts) {
      _.extend(this, opts);

      this.subViews = [];

      this.news = new NewsFormView({news_item_id: this.news_item_id});
      this.subViews.push(this.news);

      this.render();

      this.renderSubView();
    },

    template: _.template(news_form_page_template),
    subViews: [],

    render: function () {

      this.$el.html(this.template());

      return this;
    },

    renderSubView: function () {
      this.$('.news-form-page-content').html(this.news.$el);
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

